import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { ConfigProvider } from 'vant';

const app = createApp(App);

app.use(ConfigProvider).use(store).use(router).mount('#app')
